var $documentAll = require('../internals/document-all');

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/react-avatar/~/core-js/internals/is-callable.js
// module id = 90
// module chunks = 0